import { render, staticRenderFns } from "./OuterGameNewModal.vue?vue&type=template&id=b4090930&scoped=true&"
import script from "./OuterGameNewModal.vue?vue&type=script&lang=js&"
export * from "./OuterGameNewModal.vue?vue&type=script&lang=js&"
import style0 from "./OuterGameNewModal.vue?vue&type=style&index=0&id=b4090930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4090930",
  null
  
)

export default component.exports